import { render, staticRenderFns } from "./UsgsHeader.vue?vue&type=template&id=57eecec5&scoped=true"
var script = {}
import style0 from "./UsgsHeader.vue?vue&type=style&index=0&id=57eecec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eecec5",
  null
  
)

export default component.exports